/** Placeholder track_url while Mux direct upload is in progress (playback uses /api/submissions/[id]/playback). */
export const MUX_PENDING_TRACK_URL = "mux:pending";

export const AUDIO_SUBMISSION_STATUS_OPTIONS = [
	{ value: "early_sketch", label: "Early Sketch" },
	{ value: "in_progress", label: "In progress" },
	{ value: "final", label: "Final" },
] as const;
